import React, { Component } from "react";
import { Tabs } from "antd";
// import "../faqs/style.css";
import AdminTable from "./admin";
import AgentTable from "./agent";

const { TabPane } = Tabs;

class Mission extends Component {
  state = {
    // tabPosition: "top",
    admin:[],
    agent:[],
  };


  componentDidMount = () => {
    fetch(
      "https://sbhs-web-server.herokuapp.com/lte/user/all"
      // "http://localhost:4000/lte/user/all"
    )
      .then((response) => response.json())
      .then((response) => {
        const adminSide = response.filter((user) => {
          return user.usertype === "Admin"
            ? user
            : null;
        });
        const agentSide = response.filter((user) => {
          return user.usertype === "Agent"
            ? user
            : null;
        });
        // console.log("admin data", adminSide);
        // console.log("admin data", agentSide);
        this.setState({ admin: adminSide, agent: agentSide });
      });
    }
  render() {
    const { admin, agent } = this.state;
    return (
      <Tabs defaultActiveKey="0">
        <TabPane tab={"Admin  (" + admin.length + ")"} key="1">
          <AdminTable users={admin} />
        </TabPane>
        <TabPane tab={"Agent  (" + agent.length + ")"} key="2">
          <AgentTable users={agent} />
        </TabPane>
      </Tabs>
    );
  }
}

export default Mission;
